// header
export const UnitedLogo = require('./images/logo_white.png')

// social
export const LinkTree = require('./images/link_tree.png')
export const Instagram = require('./images/instagram.png')
export const Facebook = require('./images/facebook.png')
export const SoundcloudImg = require('./images/soundcloud.png')

// flyers
export const loading = require('./images/loading.gif')

// merch 
export const ComingSoon = require('./images/coming_soon.png')